import React from 'react';
import PropTypes from 'prop-types';
import Alert from './Alert';

const ErrorAlert = ({ errorLabel, retryLabel, onRetry }) => {
	return (
		<Alert
			alertIconClass="ddc-icon-alert"
			alertVariantClass="alert-warning"
		>
			<span>
				{errorLabel}
				{onRetry && retryLabel && (
					<>
						{' '}
						<button
							className="text-link"
							onClick={onRetry}
							type="button"
						>
							{retryLabel}
						</button>
					</>
				)}
			</span>
		</Alert>
	);
};

ErrorAlert.propTypes = {
	errorLabel: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.arrayOf(PropTypes.element)
	]).isRequired,
	retryLabel: PropTypes.string,
	onRetry: PropTypes.func
};

export default ErrorAlert;
